import type { Resource } from '../../';
export const forms_address_city: Resource = {"default":"City"};
